/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 18/08/2020.
 * @module IDENTITY SELECTORS
 */

/*
 *
 * IDENTITY SELECTORS
 *
 */

import { get } from "lodash";

export const makeSelectIdentityByPath = (state, path = []) =>
  get(state.identity, path);
